import axios from 'axios';
import { useCallback, useEffect, useRef } from 'react';

const useCancelToken = () => {
  const cancelTokenRef = useRef(null);

  const getCancelToken = useCallback(() => {
    const token = axios.CancelToken.source();
    if (cancelTokenRef.current) {
      cancelTokenRef.current.cancel();
    }
    cancelTokenRef.current = token;
    return token.token;
  }, []);

  useEffect(() => () => {
    if (cancelTokenRef.current) {
      cancelTokenRef.current.cancel();
    }
  }, []);

  return ({ getCancelToken });
}

export default useCancelToken;
